export default __webpack_public_path__ + "static/media/Background_00076.3ad6ee06.png";